import React from "react";
import { useOnline } from "@/lib/connectivity";
import { WifiOff } from "lucide-react";

import { useI18n } from "@/context/I18nContext";

export const ConnectionBanner: React.FC = () => {
  const {
    t
  } = useI18n();

  const online = useOnline();
  if (online) return null;
  return (
    (<div
      data-testid="connection-banner"
      className="flex items-center justify-center gap-2 bg-status-warn/15 px-4 py-1.5 text-xs font-medium text-status-warn"
    >
      <WifiOff size={14} />{t(
        "Offline — critical captures are saved on this device and will sync when you reconnect. Full offline mode is not available."
      )}</div>)
  );
};
